<template>
    <div class="font-semibold text-sm leading-tight mb-4 md:mb-8">
        <span
            v-for="(breadcrumb, index) in breadcrumbs"
            :key="index"
        >
            <nuxt-link
                :to="breadcrumb.link"
                :class="{ 'text-primary': isLastBreadcrumb(index) }"
                class="no-underline hover:text-primary transition-fast"
            >{{ breadcrumb.name }}</nuxt-link>
            <ChevronRightIcon
                v-if="!isLastBreadcrumb(index)"
                class="h-2 ml-2 mr-3 inline"
            />
        </span>
    </div>
</template>

<script>
import ChevronRightIcon from '~/static/fonts/LineIcons/chevron-right.svg';

export default {

    components: {
        ChevronRightIcon,
    },

    props: {
        breadcrumbs: {
            type: Array,
            required: true,
        },
    },

    methods: {
        isLastBreadcrumb(index) {
            return index === this.breadcrumbs.length - 1;
        },
    },

};
</script>

<style lang="scss" scoped>
</style>
